import { Component, ViewEncapsulation, ViewChild, Inject, OnInit } from '@angular/core';
import { isNullOrUndefined } from '@syncfusion/ej2-base';
import { DocumentViewerService } from 'src/app/services/document-viewer.service';
import { TypeDocument } from 'src/app/models/document-viewer';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConfirmationDialog } from '../confirmation-dialog/confirmation-dialog.component';
import { ActionDialogComponent } from '../action-dialog/action-dialog.component';
import { DomSanitizer } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { MatIconModule } from '@angular/material/icon';
import { PdfViewerModule } from 'ng2-pdf-viewer';

/**
 * Document Editor Component
 */
@Component({
	selector: 'app-pdf-viewer',
	templateUrl: './pdf-viewer.component.html',
	styleUrls: ['./pdf-viewer.component.scss'],
	imports: [MatIconModule, PdfViewerModule],
	standalone: true
})
export class PdfViewerComponent implements OnInit {
	fileURL;
	constructor(
		private documentViewerService: DocumentViewerService,
		public dialog: MatDialog,
		private snackBar: MatSnackBar,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private domSanitizer: DomSanitizer,
		private http: HttpClient,
		public dialogRef: MatDialogRef<PdfViewerComponent>
	) {}

	ngOnInit() {
		this.fileURL = this.data.pdfSrc;
	}

	close() {
		this.dialogRef.close();
	}
}
